import { toggleClass } from 'utils/toggle-classlist'
import { debounce } from 'utils/debounce'
import { formatNumber } from 'utils/format-number'
import alertHelper from 'services/alert-helper'
import marketService from 'services/market'

const $radioLower = document.querySelector<HTMLInputElement>('#lower')
const $radioHigher = document.querySelector<HTMLInputElement>('#higher')
const $inputField = document.querySelector<HTMLInputElement>('[data-rate-notification-input]')
const $range = document.querySelector<HTMLInputElement>('[data-rate-notification-slider]')
const $rangeDirection = document.querySelector<HTMLElement>('[data-range-direction]')
const $averageRateEl = document.querySelector('[data-js-selector="average-rate"]')
const $rateWarning = document.querySelector('[data-js-selector="rate-warning"]')

function setRadioValue(value: string): void {
  if (alertHelper.shouldSetHigher(value)) {
    $radioHigher.checked = true
    toggleRadiosClass()
  } else if (alertHelper.shouldSetLower(value)) {
    $radioLower.checked = true
    toggleRadiosClass()
  }
}

function toggleRadiosClass(): void {
  const $radioIcons = document.querySelectorAll<HTMLElement>('[data-js-selector="bem-radio-icon"]')
  for (const $icon of $radioIcons) {
    toggleClass($icon, 'is-hidden')
  }
}

function setSliderValue(value: string): void {
  $range.value = value
}

function doSliderChange(value: string): void {
  const trackerPosition = alertHelper.calculateTrackerPosition(value)
  setSliderValue(value)
  handleRangeDirection(trackerPosition)
  handleTipPosition(trackerPosition)
}

function handleTipPosition(trackerPosition: number): void {
  const element = document.querySelector('[data-range-tip]') as HTMLElement
  element.style.left = `${trackerPosition * 2}%`
}

function handleRateWarning(value: string): void {
  if (alertHelper.isRateWarning(value)) {
    $rateWarning.classList.remove('is-hidden')
  } else {
    $rateWarning.classList.add('is-hidden')
  }
}

function handleRangeDirection(percentage: number): void {
  $rangeDirection.style.left = `${percentage}%`
  if (percentage > 0) {
    $rangeDirection.classList.add('is-right')
  } else {
    $rangeDirection.classList.remove('is-right')
  }
}

function updateNumericInputField(value: string): void {
  $inputField.value = parseFloat(value).toFixed(4)
}

function updateSliderAttributes(): void {
  $range.min = alertHelper.getMinRangeValue().toFixed(4)
  $range.max = alertHelper.getMaxRangeValue().toFixed(4)
  $range.step = alertHelper.getStepValue().toString()
}

function updateValues(value: string) {
  updateNumericInputField(value)
  handleRateWarning(value)
  doSliderChange(value)
}

function onRadioChange(): void {
  toggleRadiosClass()
  updateValues(alertHelper.getInputValueOnRadioChange())
}

function onInputBlur(event: Event): void {
  const el = event.target as HTMLInputElement
  updateValues(el.value)
}

function onInput(event: Event): void {
  const el = event.target as HTMLInputElement
  debounce(() => {
    setRadioValue(el.value)
    handleRateWarning(el.value)
    doSliderChange(el.value)
  }, 300)
}

function onSliderChange(event: Event): void {
  const el = event.target as HTMLInputElement
  updateValues(el.value)
  setRadioValue(el.value)
}

function onSelectChange(): void {
  updateSliderAttributes()
  $averageRateEl.innerHTML = formatNumber(alertHelper.getAverageRate(), 4)
  updateValues(alertHelper.getInitRangeValue().toFixed(4))
  setRadioValue(alertHelper.getInitRangeValue().toFixed(4))
}

export function initInputValue(): void {
  window.removeEventListener('marketBrief fetched', initInputValue)

  updateSliderAttributes()
  updateValues(alertHelper.getInitRangeValue().toFixed(4))
  setRadioValue(alertHelper.getInitRangeValue().toFixed(4))
  $averageRateEl.innerHTML = formatNumber(alertHelper.getAverageRate(), 4)
}

export function initAlertNotification(isMarketFetch) {
  $radioLower?.addEventListener('change', onRadioChange)
  $radioHigher?.addEventListener('change', onRadioChange)

  $inputField?.addEventListener('blur', onInputBlur)
  $inputField?.addEventListener('input', onInput)
  $range?.addEventListener('input', onSliderChange, false)
  $range?.addEventListener('change', onSliderChange, false)

  if (isMarketFetch) marketService.fetchRates()

  window.addEventListener('marketBrief fetched', initInputValue)
  window.addEventListener('alert-select change', onSelectChange)
}
